import React from "react";

export default function ViewIdeal(props) {
  return <td> {props.quantity} units </td>;
}
